import React from 'react';
import {useNavigate} from 'react-router-dom';
import  GetLangConfig  from '../../../util/LangUtil';
import './register.success.css';
interface HandleError {
    handleError: Function;
}

export default function RegistrationSuccess(props: HandleError) {
    const history = useNavigate();
    const langConfig = GetLangConfig('preamble');
    const userDataRaw = sessionStorage.getItem('registrationSuccess');
    let userData;
//data.firstName
    if (userDataRaw) {
        userData = JSON.parse(userDataRaw);
    }

    return (
        <div className="sign-up-success-container">
            <div>
                <h1>{langConfig.register.welcome} {userData.firstName}</h1>
                <p>{langConfig.register.p58}</p>
                <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped " onClick={e=>history('/login')}>
                    <div className="mdc-button__ripple"></div>
                    <span className="mdc-button__label">{langConfig.login.loginBtn}</span>
                </button>
            </div>
        </div>
    );
}